// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZaYtM","comment":"styles_comment__zzD2_"};